import React from 'react'
// 
import Script from 'next/script'
import Link from 'next/link'
import styles from '../../styles/Home.module.css'
import { AppBar, IconButton, Stack, Toolbar, Typography, Button } from '@mui/material'
import { ElectricBolt } from '@mui/icons-material'

const Navbar = () => {


  return (
    <AppBar position='static' style={{backgroundColor: 'rgb(75, 100, 194)'}}>
      <Toolbar>
        <IconButton size ='medium' edge='start' color='inherit' aria-label='logo' href='./tenants'>
          <ElectricBolt></ElectricBolt>
        </IconButton>
        <Typography variant='h6' component='div' sx={{flexGrow: 1}}>
          Tenant Service
        </Typography>
        <Stack direction= 'row' spacing={2}>
          <Button color='inherit' href='./tenants'>Tenants</Button>
          <Button color='inherit' href='./settings'>Settings</Button>

        </Stack>
      </Toolbar>
    </AppBar>
  )

}

export default Navbar